import { render, staticRenderFns } from "./ZodiacPeople.vue?vue&type=template&id=dac0805a&"
import script from "./ZodiacPeople.vue?vue&type=script&lang=js&"
export * from "./ZodiacPeople.vue?vue&type=script&lang=js&"
import style0 from "./ZodiacPeople.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports